import React from 'react';
export function Footer() {
  return <footer className="bg-black text-gray-400 py-12 px-4 border-t border-zinc-900 text-center" data-id="element-71">
      <div className="max-w-4xl mx-auto" data-id="element-72">
        <div className="font-display font-black text-2xl text-white mb-4" data-id="element-73">
          📚 BIBLIOTECA PRO™
        </div>
        <p className="mb-8 max-w-md mx-auto" data-id="element-74">
          El sistema de transformación N°1 para mujeres argentinas de 35 a 52
          años. Porque bajar de peso después de los 40 no debería costarte todos
          los lunes del año.
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-6 mb-12 text-sm" data-id="element-75">
          <a href="mailto:bibliotecapro2026@gmail.com" className="hover:text-brand transition-colors" data-id="element-76">
            📧 bibliotecapro2026@gmail.com
          </a>
          <span className="hidden md:inline" data-id="element-77">•</span>
          <a href="https://www.bibliotecapro.online" className="hover:text-brand transition-colors" data-id="element-78">
            🌐 www.bibliotecapro.online
          </a>
        </div>

        <div className="text-xs text-zinc-600" data-id="element-79">
          © Biblioteca Pro™ 2026 — Todos los derechos reservados. Prohibida la
          reproducción y redistribución sin autorización expresa.
        </div>
      </div>
    </footer>;
}